export default defineNuxtRouteMiddleware((to, from) => {
  if (to.path.startsWith('/_nuxt')) {
    console.warn('NUXT4 - BP Repo - Unexpected navigation to asset path:', to.path, 'from:', from.path, 'fullPath:', to.fullPath)
    return
  }

  if (to.path === from.path) {
    console.log('NUXT4 - BP Repo - Navigate to', to.path)
  } else {
    console.log('NUXT4 - BP Repo - Navigate to', to.path, 'from', from.path)
  }
})
